<template lang="pug">
.Log
  .Log-text(v-if='text') {{ text }}
  .Log-text(
    v-if='htmlText',
    v-html='htmlText'
  )
  .Log-text(v-if='errors') {{ errors }}
  .Log-text(v-if='!errors && (!text && !htmlText) && !isLoading') Запуска не было или логи отсутствуют
  .Log-text(v-if='isLoading') Загрузка
</template>

<script>
export default {
  name: 'log',
  props: {
    text: '',
    htmlText: String,
    errors: '',
    isLoading: false
  }
}
</script>

<style lang="scss">
@import '~base';

#app .Log,
.Popup .Log {
  --logColor: #{$grey8};
  --shadowColor: #{$grey7};
}

#app[data-theme='dark'] .Log,
.Popup[data-theme='dark'] .Log {
  --logColor: #{$grey1};
  --shadowColor: #{$grey8};
}
</style>
<style scoped lang="scss">
.Log {
  max-height: 167px;
  overflow: auto;
  border: 1px solid var(--shadowColor);
  font-size: 11px;
  color: var(--logColor);

  &-text {
    padding: 15px;
    overflow-wrap: break-word;
    word-wrap: break-word;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modeling/Log.vue